import { useState } from "react";
import { Exercise } from "../../../models/Exercise";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import { GET_SCHEDULE_DETAILS, GET_SCHEDULE_DETAILS_NOLOGIN, JOIN_TO_EXERCISE } from "../../../api/apiRoutes";
import useApiRequest from "../../../../utils/hooks/useApiRequest";
import useFacility from "../../../../utils/hooks/useFacility";

/* eslint-disable import/no-anonymous-default-export */
export default (exercise: Exercise, onRefreshExercises: () => void) => {
  const facilityIds = useFacility();
  const { get, post } = useApiRequest();
  const userDataId = useSelector((state: State) => state.auth.userData.objectId);
  const [exerciseDetails, setExerciseDetails] = useState<Exercise>(exercise);
  const [alerts, setAlerts] = useState<string>("");

  const getDetailsAboutExercise = async () => {
    if (userDataId) {
      const { result, isError } = await get(
        GET_SCHEDULE_DETAILS(facilityIds, `0,${exercise.objectId}`, `0,${userDataId}`)
      );
      if (!isError) {
        setExerciseDetails(result);
      }
    }
    if (!userDataId) {
      const { result, isError } = await get(GET_SCHEDULE_DETAILS_NOLOGIN(facilityIds, `0,${exercise.objectId}`));
      if (!isError) {
        setExerciseDetails(result);
      }
    }
  };

  const handleJoinToExercise = (assignType: boolean, passId: string) => {
    joinToExercise(exercise.objectId, assignType, passId, () => onJoinSuccess());
  };

  const onJoinSuccess = () => {
    getDetailsAboutExercise();
    onRefreshExercises();
  };

  const joinToExercise = async (exerciseId: number, assigned: boolean, passId: string, onFinish: () => void) => {
    const { isError, errorTable } = await post(JOIN_TO_EXERCISE(facilityIds, passId), {
      exerciseIds: exerciseId,
      webUserIds: `0,${userDataId}`,
      assigned: assigned,
    });

    if (!isError) {
      onFinish();
    }
    if (isError) {
      setAlerts(errorTable[0]);
      setTimeout(() => {
        setAlerts("");
      }, 5000);
    }
  };

  return { exerciseDetails, handleJoinToExercise, alerts };
};
